// extracted by mini-css-extract-plugin
export default {"container":"statistics_container__BXhY-","content":"statistics_content__VtYsS"};